<template>
  <el-drawer
    title="New group..."
    v-model="isGroupModal"
    direction="btt"
    class="createTask"
    size="100%"
  >
    <el-form
      ref="ruleFormRef"
      :model="form"
      :rules="rules"
      label-width="120px"
      status-icon
      label-position="top"
    >
      <el-form-item label="Title" prop="title">
        <el-input v-model="form.title" />
      </el-form-item>

      <el-form-item label="Text" prop="text">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="Describe this group"
          v-model="form.text"
        >
        </el-input>
      </el-form-item>

      <el-button
        type="success"
        @click="submitForm('ruleFormRef')"
        :loading="loading"
      >
        Save
      </el-button>
    </el-form>
  </el-drawer>
</template>


<script>
import ApiGroup from "@/api/group";

import _ from "lodash";
import { mapActions } from "vuex";
export default {
  computed: {
    isGroupModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      copyTaskList: [],

      loading: false,
      form: {},
      rules: {
        title: [
          { required: true, message: "Please input title", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    ...mapActions("User", ["getGroupList"]),
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          ApiGroup.create(this.form).then((responce) => {
            if (!responce.status) {
              this.$notify({
                title: "Error",
                message: "Something wrong",
                type: "error",
              });
            } else {
              this.$notify({
                title: "Success",
                message: "The group was create",
                type: "success",
              });
              this.$refs[formName].resetFields();
              this.$emit("createdGroup");
              setTimeout(() => {
                this.getGroupList();
              }, 500);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  mounted() {},
};
</script>
